module.exports = __webpack_public_path__ + "img/Developer.22ad32fb.png";